import { Card } from "antd";
import useViewport from "components/UseViewport/UseViewport";

const Calendar = () => {
  const { width } = useViewport();
  const breakpoint = 500;
  return (
    <Card title="BL-kalender">
      <iframe
        title="Bindeleddet"
        src={
          width < breakpoint
            ? "https://calendar.google.com/calendar/embed?height=600&wkst=2&bgcolor=%23ffffff&ctz=Europe%2FOslo&showTabs=0&showTz=0&showCalendars=0&showPrint=0&showDate=1&showNav=1&showTitle=0&mode=AGENDA&src=cDluOXRjOWxhcjQ4anViZ2lpaXY3bGUxMGtAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&color=%23AD1457"
            : "https://calendar.google.com/calendar/embed?height=600&wkst=2&bgcolor=%23ffffff&ctz=Europe%2FOslo&showTabs=1&showTz=0&showCalendars=0&showPrint=0&showDate=1&showNav=1&showTitle=0&src=cDluOXRjOWxhcjQ4anViZ2lpaXY3bGUxMGtAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&color=%23AD1457"
        }
        style={{ border: "solid 1px #777" }}
        width="100%"
        height="600"
        scrolling="no"
      />
    </Card>
  );
};
export default Calendar;
